import moment from 'moment';
import { getDtd, getFareType, passengerCount } from '../../../../utilities/helpers';
import { sendAncillaryEventToCustomerIO } from '../../../../utilities/customer-io-ancillary-events';
import { CARRY_ON_LABELS } from './constants';

export default (pnrData, ancillaryOfferCollectionModel, isSignIn, minCPPrice, minPPPrice) => {
  const pnrInfo = pnrData;
  const items = [];
  let tripType = 'MC';
  const segments = [];
  let zone = 'NA';
  const legCollection = pnrInfo?.legCollection || [];
  const outboundSegments = legCollection?.[0]?.segmentsCollection || [];
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection || [];
  let stopNumbers = 0;

  if (pnrInfo?.flightItineraryType === 'ONEWAY') {
    tripType = 'OW';
  } else if (pnrInfo?.flightItineraryType === 'ROUNDTRIP') {
    tripType = 'RT';
  }

  if (legCollection?.length > 0) {
    legCollection.forEach((element) => {
      const data = element?.segmentsCollection;
      stopNumbers = data?.length > 1 ? stopNumbers + (data?.length - 1) : stopNumbers;
      data.forEach((segmentsData) => {
        segments.push(segmentsData);
      });
    });
  }

  const apiDepartureDate = moment(segments?.[0]?.departureDateTime);
  const transactionDate = moment(pnrInfo?.creationDate);
  const apiItem = apiDepartureDate.diff(transactionDate, 'days');
  const dtd = getDtd(segments?.[0]?.departureDateTime);
  const inboundDepartureDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';
  const inboundArrivalDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';
  const arrivalAirport = outboundSegments?.[outboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const departureAirport = outboundSegments?.[0]?.departureAirport || 'NA';
  const marketOd = `${departureAirport}${arrivalAirport}`;
  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');

  const apItemRanges = [
    { min: 0, max: 2, range: '0 a 2' },
    { min: 3, max: 6, range: '3 a 6' },
    { min: 7, max: 13, range: '7 a 13' },
    { min: 14, max: 20, range: '14 a 20' },
    { min: 21, max: 27, range: '21 a 27' },
    { min: 28, max: 49, range: '28 a 49' },
    { min: 50, max: 89, range: '50 a 89' },
    { min: 90, max: 119, range: '90 a 119' },
    { min: 120, max: 149, range: '120 a 149' },
    { min: 150, max: Infinity, range: '150+' },
  ];
  
  const apItemRange = apItemRanges.find(({ min, max }) => apiItem >= min && apiItem <= max)?.range || 'NA';

  let msItem = 0;
  if (tripType === 'RT') {
    const firstSegment = moment(segments?.[0]?.departureDateTime);
    const lastSegment = moment(segments?.[segments?.length - 1]?.arrivalDateTime);
    msItem = lastSegment.diff(firstSegment, 'days');
  }

  const marketSegments = (legCollection || []).map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = (segmentCollection || []).map(segment => {
      return `${segment?.departureAirport || 'NA'}${segment?.arrivalAirport || 'NA'}`;
    }).join('/');
    return segments;
  }).join('-');
  
  let marketNdod = `${arrivalAirport}${departureAirport}` || 'NA';
  if (departureAirport < arrivalAirport) {
    marketNdod = `${departureAirport}${arrivalAirport}`;
  }

  const bookingClassTest = [];
  const cabinClassTest = [];
  (legCollection || []).forEach((element) => {
    const segmentsInfo = element?.segmentsCollection;
    const bookingClass = [];
    const cabinClass = [];
    (segmentsInfo || []).forEach((segmentsData) => {
      bookingClass.push(segmentsData?.bookingClass || 'NA');
      cabinClass.push(segmentsData?.cabin || 'NA');
    });
    bookingClassTest.push(bookingClass.join('/'));
    cabinClassTest.push(cabinClass.join('/'));
  });
  const bookingClassSegment = bookingClassTest.join('-');
  const cabinClassSegment = cabinClassTest.join('-');

  const travelerCollection = pnrInfo?.cart?.travelerCollection || [];
  const travelerCount = passengerCount(travelerCollection);
  const mktCarrier = legCollection.map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = (segmentCollection || []).map(segment => {
      return `${segment?.marketingCarrier || 'NA'}`;
    }).join('/');
    return segments;
  }).join('-');
  const market = pnrInfo?.globalMarketFlight;

  if (market === 'DOMESTIC') {
    zone = 'DOM';
  } else if (market === 'INTERNATIONAL' || market === 'TRANSBORDER') {
    zone = 'INT';
  }

  const brandedFare = [];
  const itemName = [];
  let zoneItem = '';
  let regionItem = '';
  const departureDateTime = [];
  const outboundDepartureDateItem = [];
  let flightTimeMinutes = 0;
  (legCollection || []).forEach((legs, legIndex) => {
    const itemNameOWType = legs?.segmentsCollection?.[0]?.departureAirport + legs?.segmentsCollection?.[0]?.arrivalAirport;
    const itemNameRTType = legs?.segmentsCollection?.[0]?.departureAirport + legs?.segmentsCollection?.[1]?.arrivalAirport;
    if (tripType !== 'MC' && legIndex === 0) {
      if ((tripType === 'OW' || tripType === 'RT') && legs?.segmentsCollection?.length === 1) {
        itemName.push(itemNameOWType);
      } else {
        itemName.push(itemNameRTType);
      }
    } else if (tripType === 'MC') {
      if (legs?.segmentsCollection?.length === 1) {
        itemName.push(itemNameOWType);
      } else {
        itemName.push(itemNameRTType);
      }
    }

    const brandedFareSegments = [];
    const outboundDepartureSegments = [];
    const departureDateTimeSegments = [];
    (legs?.segmentsCollection || []).forEach((passenger, index) => {
      let brandFare = getFareType(passenger);
      brandFare = brandFare === 'MAIN_LIGHT' ? 'LIGHT' : brandFare;

      if (index === 0 && legIndex === 0 && tripType !== 'MC') {
        departureDateTime.push(moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss'));
        flightTimeMinutes = passenger?.flightDurationInMinutes;
        outboundDepartureDateItem.push(passenger?.departureDateTime?.format('YYYYMMDD'));
        brandedFare.push(brandFare);
      } else if (tripType === 'MC') {
        departureDateTimeSegments.push(moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss'));
        flightTimeMinutes += passenger?.flightDurationInMinutes;
        outboundDepartureSegments.push(passenger?.departureDateTime?.format('YYYYMMDD'));
        brandedFareSegments.push(brandFare);
      }

      if (tripType !== 'MC') {
        zoneItem = passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT';
        regionItem = passenger?.regionKeyFromLeg;
      } else if (index === legs.segmentsCollection.length - 1) {
        zoneItem = passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT';
        regionItem = passenger?.regionKeyFromLeg;
      }
    });

    if (tripType === 'MC') {
      brandedFare.push(brandedFareSegments.join('/'));
      outboundDepartureDateItem.push(outboundDepartureSegments.join('/'));
      departureDateTime.push(departureDateTimeSegments.join('/'));
    }
  });

  let params = {};
  const flightTime = moment.utc(flightTimeMinutes * 60000).format('HH:mm');
  let baggageCount = 0;
  legCollection.forEach((legs, legIndex) => {
    (legs?.segmentsCollection || []).forEach((passenger, index) => {
      const itemBrand = 'AM';
      const itemCategory = 'Ancillary';
      const marketOdItem = passenger?.departureAirport + passenger?.arrivalAirport;
      const opCarrier = passenger?.operatingCarrier;
      const baggageData = Object.values(ancillaryOfferCollectionModel)?.[0]?.filter(bag => bag?.extraBags)?.[0];
      const handLuggageData = baggageData?.carryOn?._ancillaries?.[0];
      const itemListName = 'Ancillaries';

      if (baggageData) {
        Object.values(baggageData?.extraBags?._ancillaries).forEach((baggage, baggageIndex) => {
          params = {
            'item_name': itemName.join('-') || 'NA',
            'coupon': 'NA',
            'discount': 0,
            'fop_type': 'Cash',
            'item_brand': itemBrand,
            'item_category': itemCategory,
            'item_category2': 'Luggage',
            'item_category3': 'NA',
            'item_list_name': itemListName,
            'item_affiliation': 'AM',
            'price': baggage?.currencyPerLegArray[0].currency.total,
            'quantity': 1,
            'index': baggageIndex,
            'booking_fee_amrpoints': 0,
            'market_ndod_item': marketNdod || 'NA',
            'market_od_item': marketOdItem || 'NA',
            'market_segment_item': marketOdItem || 'NA',
            'zone_item': zoneItem || 'NA',
            'region_item': regionItem || 'NA',
            'flight_time_dep': departureDateTime.join('-') || 'NA',
            'flight_time': flightTime || 'NA',
            'branded_fare': brandedFare.join('-') || 'NA',
            'outbound_departure_date_item': outboundDepartureDate || 'NA',
            'inbound_departure_date_item': inboundDepartureDate,
            'price_points': isSignIn ? minCPPrice : 0,
            'airport_tax': pnrInfo?.cart?.total?.taxDetails?.TUA || 0,
            'aircraft_type': passenger?.aircraftType || 'NA',
            'aircraft_subfleet': `${opCarrier}${passenger?.aircraftType}` || 'NA',
            'ap_item': apItemRange,
            'op_carrier': opCarrier || 'NA',
            'ms_item': msItem,
            'cabin_item': tripType === 'MC' ? cabinClassSegment : passenger?.cabin || 'NA',
            'class_item': tripType === 'MC' ? bookingClassSegment : passenger?.bookingClass || 'NA',
          };
          if (legIndex === 0 && baggageIndex === 0 && baggageCount < 1) { 
            baggageCount = +1;
            items.push(params); 
          }
        });
      }

      if (handLuggageData) {
        const isMainLight = brandedFare.includes('LIGHT');
        const isBasic = brandedFare.includes('BASIC');
        const itemCategory2 = isMainLight || isBasic ? CARRY_ON_LABELS.CARRY_ON : 'NA';
        const itemCategory3 = isMainLight ? CARRY_ON_LABELS.CARRY_ON_10KG : isBasic ? CARRY_ON_LABELS.CARRY_ON_PLUS_5KG : 'NA';
        params = {
          'item_name': itemName.join('') || 'NA',
          'coupon': 'NA',
          'discount': 0,
          'fop_type': 'Cash',
          'item_brand': itemBrand,
          'item_category': itemCategory,
          'item_category2': itemCategory2,
          'item_category3': itemCategory3,
          'item_list_name': itemListName,
          'item_affiliation': 'AM',
          'price': handLuggageData?.currency?.total,
          'quantity': 1,
          'index': index,
          'booking_fee_amrpoints': 0,
          'market_ndod_item': marketNdod || 'NA',
          'market_od_item': marketOdItem || 'NA',
          'market_segment_item': marketOdItem || 'NA',
          'zone_item': zoneItem || 'NA',
          'region_item': regionItem || 'NA',
          'flight_time_dep': departureDateTime.join('-') || 'NA',
          'flight_time': flightTime || 'NA',
          'branded_fare': brandedFare.join('-') || 'NA',
          'outbound_departure_date_item': outboundDepartureDateItem.join('-') || 'NA',
          'inbound_departure_date_item': inboundDepartureDate,
          'price_points': isSignIn ? minPPPrice : 0,
          'airport_tax': pnrInfo?.cart?.total?.taxDetails?.TUA || 0,
          'aircraft_type': passenger?.aircraftType || 'NA',
          'aircraft_subfleet': `${opCarrier}${passenger?.aircraftType}` || 'NA',
          'ap_item': apItemRange,
          'op_carrier': opCarrier || 'NA',
          'ms_item': msItem,
          'cabin_item': tripType === 'MC' ? cabinClassSegment : passenger?.cabin || 'NA',
          'class_item': tripType === 'MC' ? bookingClassSegment : passenger?.bookingClass || 'NA',
        };
        if (legIndex === 0 && index === 0) items.push(params);
      }
    });
  });

  const result = {
    event: 'view_item_list',
    ecommerce: {
      'search_filter': 'NA',
      'funnel_name': 'MYB',
      'sub_funnel_name': 'Ancillary',
      'trip_type': tripType,
      'fop_type': 'Cash',
      'outbound_departure_date': outboundDepartureDate || 'NA',
      'inbound_departure_date': inboundDepartureDate,
      'outbound_arrival_date': outboundArrivalDate || 'NA',
      'inbound_arrival_date': inboundArrivalDate,
      'zone': zone,
      'market_od': marketOd || 'NA',
      'market_ndod': marketNdod || 'NA',
      'market_segment': marketSegments || 'NA',
      'mkt_carrier': mktCarrier,
      'region': legCollection?.[0]?.regionKey || 'NA',
      'value_points': pnrInfo?.cart?.points || 0,
      'adults': travelerCount?.adults,
      'childs': travelerCount?.child,
      'adult_minors': travelerCount?.adultMinors,
      'infants': travelerCount?.infants,
      'stops_number': stopNumbers,
      'dtd': dtd || 'NA',
      'clid_benefits': 'NA',
      'cabin': cabinClassSegment || 'NA',
      'class': bookingClassSegment || 'NA',
      'items': items,
    },
  };

  try {
    sendAncillaryEventToCustomerIO('ckdbags', result, pnrInfo);
  } catch (error) {
    // Silent error
  }


  return result;
};
